module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('div', {
    staticClass: "fixed-top-menu-outer",
    attrs: {
      "id": "fixed-top-menu-outer"
    }
  }, [_c('div', {
    staticClass: "fixed-top-menu"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setupDownload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Kártyaolvasó illesztő letöltése")])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("\n          Kezdőőoldal\n        ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Kezdőoldal")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-panel-top-btn-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setupDownload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Kártyaolvasó illesztő letöltése")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.docs), function(doc) {
    return _c('section', [_c('a', {
      staticClass: "active",
      attrs: {
        "href": 'docs/' + doc.file,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(doc.name))]), _vm._v(" - " + _vm._s(doc.date) + " (v" + _vm._s(doc.version) + ")"), _c('br')])
  }), 0)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Kezdőoldal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Üdvözöljük")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n              A rendszer használatához válasszon a bal oldali menüpontok közül!\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Letölthető dokumentumok")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-466972b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/home.vue
// module id = 55
// module chunks = 0